import { Order } from '../../../../app/models/business/Order';
import { OperationStatus } from '../../../../app/models/business/OperationStatus';

interface UseStatusPaymentProps {
  order: Order;
  statusPayments: OperationStatus[];
}

export const useStatusPayment = ({ statusPayments }: UseStatusPaymentProps) => {
  return statusPayments.filter((status) =>
    ['CS Yellow', 'Rejected', 'Approved'].includes(status.name),
  );
};
